import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert,  Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import {  CCRConfig, sbConfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface CCRConfigViewProps {
    gsb: AxiosInstance,
    CCRConfig: CCRConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function CCRConfigView({ gsb, CCRConfig = {} as CCRConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: CCRConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

     const [CHQ_NAME, setCHQ_NAME] = useState(false)
     const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
     const [CM2K_USER, setCM2K_USER] = useState(false)
     const [GSBx_USER, setGSBx_USER] = useState(false)

  //   const [def_d_CCOMMOPT,setdef_d_CCOMMOPT] = useState(CCRConfig.d_CCOMMOPT)
    // const [def_d_CCOMDIR,setdef_d_CCOMDIR] =useState(CCRConfig.d_CCOMDIR)
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC)               
                setCHQ_NAME(GsbFlag.CHQ_NAME)
                setCM2K_USER( GsbFlag.CM2K_USER);
                //console.log("set StatusList: ", StatusList)
 
                setGSBx_USER(GsbFlag.GSBx_USER) ;
               
                //console.log(CCRConfig)
                
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CCRConfig ])



    if (! ("d_CCOMMDIR" in CCRConfig)) return null


    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                
            </div>
            <div className="Spacing-V-16" />
            {/*
            <div className="Row">
                <FormGroup className="Col-1-2" label="System Date">
                    <InputGroup readOnly value= {utils.dispDate(BcanConfig.d_tr_date, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-1" label="OwnPartID">                   
                </FormGroup>
                <FormGroup className="Col-3-1">
                    <InputGroup readOnly value={CCRConfig.x_OWN_PARTID} />
                </FormGroup>
                <FormGroup className="Col-5-1" label="OwnBIC">
                </FormGroup>
                <FormGroup className="Col-6-1" >
                    <InputGroup readOnly value={CCRConfig.x_OWN_BIC} />
                </FormGroup>                
                <FormGroup className="Col-1-2" label="CCASS Directory Name">
                </FormGroup>
                <FormGroup className="Col-3-2">
                    <InputGroup readOnly value={CCRConfig.d_CCOMMDIR} />
                </FormGroup>
 
                <FormGroup className="Col-1-2" label="Constant Recipient 1"> 
                </FormGroup>
                <FormGroup className="Col-3-2" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMAC1} />                                         
                </FormGroup>
                <FormGroup className="Col-1-2" label="Constant Recipient 2"> 
                </FormGroup>
                <FormGroup className="Col-3-2" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMAC2} />                                         
                </FormGroup>     

                <FormGroup className="Col-1-2" label="Constant Recipient 3"> 
                </FormGroup>
                <FormGroup className="Col-3-2" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMAC3} />                                         
                </FormGroup>  

                <FormGroup className="Col-1-2" label="Constant Recipient 4"> 
                </FormGroup>
                <FormGroup className="Col-3-2" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMAC4} />                                         
                </FormGroup>  

                <FormGroup className="Col-1-2" label="Constant Recipient 5"> 
                </FormGroup>
                <FormGroup className="Col-3-2" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMAC5} />                                         
                </FormGroup>  


            </div>
 
            <div className="Row">
              
              <FormGroup className="Col-1-2" label="Receive Option (1-8)"> 
              </FormGroup>

              <FormGroup className="Col-3-2">
                  <select  id="inputCCOMPOPT" disabled={true} value={CCRConfig.d_CCOMMOPT} >                      
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                  </select>
 
              </FormGroup>
      
          </div>


            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="BROKER COMPANY NAME">            
                </FormGroup>
                <FormGroup className="Col-3-5" >
                    <InputGroup readOnly value={CCRConfig.x_BKR_NAME} />
                </FormGroup>
            </div>
            <div className="Row">
   
                <FormGroup className="Col-1-2" label="BROKER OWN ADDRESS">

                </FormGroup>
                <FormGroup className="Col-3-5" >
                    <InputGroup readOnly value={CCRConfig.d_CCOMMADR1} />
                    <InputGroup readOnly value={CCRConfig.d_CCOMMADR2} />
                    <InputGroup readOnly value={CCRConfig.d_CCOMMADR3} />
                    <InputGroup readOnly value={CCRConfig.d_CCOMMADR4} />
                </FormGroup>
            
            </div>
            <div className="Spacing-V-16"></div>
            <br></br>
            <p>Notes</p>
            <div>
                <div>Re: HKEx Circular CBU/CC/DNS/034/2003</div>
            
            </div >
           
        </div>
    )
}

interface CCRConfigEditProps {
    gsb: AxiosInstance,
    CCRConfig?: CCRConfig,
    isNew?: boolean,
    onSave?: (BcanConfig: CCRConfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function CCRConfigEdit({ gsb, CCRConfig = {} as CCRConfig, isNew = false, onSave = () => { }, onCancel = () => { } }: CCRConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CCRConfig>()
  
    //const [def_d_OwnPartID, setdd_OwnPartID] = useState(CCRConfig.d_OwnPartID)

    const [CHQ_NAME, setCHQ_NAME] = useState(false)    
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)  
    const [CM2K_USER, setCM2K_USER] = useState(false)
    const [GSBx_USER, setGSBx_USER] = useState(false) 
    const [def_Own_PartID,setdef_Own_PartID] = useState(CCRConfig.x_OWN_PARTID)
    const [def_OWN_BIC,setdef_OWN_BIC] = useState(CCRConfig.x_OWN_BIC)    
    const [def_BKR_NAME,setdef_BKR_NAME] = useState(CCRConfig.x_BKR_NAME)
    const [def_d_CCOMMDIR,setdef_d_CCOMMDIR] = useState(CCRConfig.d_CCOMMDIR)
    const [def_d_CCOMMAC1,setdef_d_CCOMMAC1] = useState(CCRConfig.d_CCOMMAC1)   
    const [def_d_CCOMMAC2,setdef_d_CCOMMAC2] = useState(CCRConfig.d_CCOMMAC2)   
    const [def_d_CCOMMAC3,setdef_d_CCOMMAC3] = useState(CCRConfig.d_CCOMMAC3)   
    const [def_d_CCOMMAC4,setdef_d_CCOMMAC4] = useState(CCRConfig.d_CCOMMAC4)      
    const [def_d_CCOMMAC5,setdef_d_CCOMMAC5] = useState(CCRConfig.d_CCOMMAC5)       

    const [def_d_CCOMMADR1,setdef_d_CCOMMADR1] = useState(CCRConfig.d_CCOMMADR1) 
    const [def_d_CCOMMADR2,setdef_d_CCOMMADR2] = useState(CCRConfig.d_CCOMMADR2) 
    const [def_d_CCOMMADR3,setdef_d_CCOMMADR3] = useState(CCRConfig.d_CCOMMADR3)     
    const [def_d_CCOMMADR4,setdef_d_CCOMMADR4] = useState(CCRConfig.d_CCOMMADR4)     
    const [def_d_CCOMMOPT,setdef_d_CCOMMOPT] = useState(CCRConfig.d_CCOMMOPT)       
    
    useEffect(() => {
        // Call reset to set default values if ac is passed

       
        
        if ("d_CCOMDIR" in CCRConfig) {
            reset(CCRConfig)
        }
    }, [CCRConfig, reset])

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC) ;              
                setCHQ_NAME(GsbFlag.CHQ_NAME);
                //console.log("set StatusList: ", StatusList)
                setCM2K_USER( GsbFlag.CM2K_USER);
                setGSBx_USER(GsbFlag.GSBx_USER) ;

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CCRConfig])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {

         if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

    if (! isNew && !("d_CCOMMDIR" in CCRConfig)) return null


    const onSubmit = (data: CCRConfig) => {
        //console.log("onsubmit called", data)

        // put value to json/field before write database dbf
       // data.d_OwnPartID = data.d_OwnPartID.toUpperCase();
       data.x_BKR_NAME = def_BKR_NAME.toUpperCase();
       data.x_OWN_PARTID = def_Own_PartID;
       data.x_OWN_BIC = def_OWN_BIC;
       data.d_CCOMMDIR = def_d_CCOMMDIR.toUpperCase();     
       data.d_CCOMMAC1 = def_d_CCOMMAC1.toUpperCase();
       data.d_CCOMMAC2 = def_d_CCOMMAC2.toUpperCase();
       data.d_CCOMMAC3 = def_d_CCOMMAC3.toUpperCase();
       data.d_CCOMMAC4 = def_d_CCOMMAC4.toUpperCase();              
       data.d_CCOMMAC5 = def_d_CCOMMAC5.toUpperCase();       
       data.d_CCOMMADR1 = def_d_CCOMMADR1.toUpperCase();       
       data.d_CCOMMADR2 = def_d_CCOMMADR2.toUpperCase();       
       data.d_CCOMMADR3 = def_d_CCOMMADR3.toUpperCase();       
       data.d_CCOMMADR4 = def_d_CCOMMADR4.toUpperCase();       
       data.d_CCOMMOPT = def_d_CCOMMOPT;
 

        (async () => {
            try {
                //console.log("call CCRConfigEdit data", data)
                //console.log("call CCRConfigEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CCRConfig", cAction: "CCRConfigValidate", isNew: isNew})
                //console.log("CCRConfigEdit res.data.ok", res.data.ok)
                //console.log("CCRConfigEdit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
                onSave(data)
            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
        
            <div className="Row">
                <FormGroup className="Col-1-1" label="OwnPartID">                  
                </FormGroup>
                <FormGroup className="Col-3-1">   
                    <InputGroup id="inputOwnPartID" defaultValue={def_Own_PartID} value={def_Own_PartID} onChange={utils.handleStringChange(n => setdef_Own_PartID(n))} />                      
                    {errors.x_OWN_PARTID && errors.x_OWN_PARTID.types && <span id="Err_msg">{errors.x_OWN_PARTID.types.message}</span>}
                </FormGroup>                      
                <FormGroup className="Col-5-1" label="OwnBIC">   
                </FormGroup>
                <FormGroup className="Col-6-1">   
                    <InputGroup id="inputOwnBIC" defaultValue={def_OWN_BIC} value={def_OWN_BIC} onChange={utils.handleStringChange(n => setdef_OWN_BIC(n))} />                      
                    {errors.x_OWN_BIC && errors.x_OWN_BIC.types && <span id="Err_msg">{errors.x_OWN_BIC.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-1-2" label="CCASS Directory Name">                  
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputOwnPartID" defaultValue={def_d_CCOMMDIR} value={def_d_CCOMMDIR} onChange={utils.handleStringChange(n => setdef_d_CCOMMDIR(n))} />                      
                    {errors.d_CCOMMDIR && errors.d_CCOMMDIR.types && <span id="Err_msg">{errors.d_CCOMMDIR.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Constant Recipient 1"> 
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputCCOMMAC1" defaultValue={def_d_CCOMMAC1} value={def_d_CCOMMAC1} onChange={utils.handleStringChange(n => setdef_d_CCOMMAC1(n))} />                      
                </FormGroup>
                <FormGroup className="Col-5-3">   
                    {errors.d_CCOMMAC1 && errors.d_CCOMMAC1.types && <span id="Err_msg">{errors.d_CCOMMAC1.types.message}</span>}
                </FormGroup>


                <FormGroup className="Col-1-2" label="Constant Recipient 2"> 
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputCCOMMAC2" defaultValue={def_d_CCOMMAC2} value={def_d_CCOMMAC2} onChange={utils.handleStringChange(n => setdef_d_CCOMMAC2(n))} />                      

                </FormGroup>
                <FormGroup className="Col-5-3">  
                    {errors.d_CCOMMAC2 && errors.d_CCOMMAC2.types && <span id="Err_msg">{errors.d_CCOMMAC2.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-1-2" label="Constant Recipient 3"> 
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputCCOMMAC3" defaultValue={def_d_CCOMMAC3} value={def_d_CCOMMAC3} onChange={utils.handleStringChange(n => setdef_d_CCOMMAC3(n))} />  
                </FormGroup>
                <FormGroup className="Col-5-3"> 
                    {errors.d_CCOMMAC3 && errors.d_CCOMMAC3.types && <span id="Err_msg">{errors.d_CCOMMAC3.types.message}</span>}                    
                </FormGroup>
                <FormGroup className="Col-1-2" label="Constant Recipient 4"> 
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputCCOMMAC4" defaultValue={def_d_CCOMMAC4} value={def_d_CCOMMAC4} onChange={utils.handleStringChange(n => setdef_d_CCOMMAC4(n))} />                      
                </FormGroup>
                <FormGroup className="Col-5-3"> 
                    {errors.d_CCOMMAC4 && errors.d_CCOMMAC4.types && <span id="Err_msg">{errors.d_CCOMMAC4.types.message}</span>}                   
                </FormGroup>
                <FormGroup className="Col-1-2" label="Constant Recipient 5"> 
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup id="inputCCOMMAC5" defaultValue={def_d_CCOMMAC5} value={def_d_CCOMMAC5} onChange={utils.handleStringChange(n => setdef_d_CCOMMAC5(n))} />                      
                </FormGroup>
                <FormGroup className="Col-5-3"> 
                    {errors.d_CCOMMAC5 && errors.d_CCOMMAC5.types && <span id="Err_msg">{errors.d_CCOMMAC5.types.message}</span>}                 
                </FormGroup>
            </div>
            <div className="Row">
              
                <FormGroup className="Col-1-2" label="Receive Option (1-8)"> 
                </FormGroup>
                <FormGroup className="Col-3-2">
                    <select  id="inputCCOMPOPT"  value={def_d_CCOMMOPT} onChange={utils.handleStringChange(s => setdef_d_CCOMMOPT(s)) } ref={register}>                      
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                    </select>   
                </FormGroup>        
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="BROKER COMPANY NAME">            
                </FormGroup>
                <FormGroup className="Col-3-5" >
              <InputGroup id="inputBKR_NAME" defaultValue={def_BKR_NAME} value={def_BKR_NAME} onChange={utils.handleStringChange(n => setdef_BKR_NAME(n))} />                      
                
                </FormGroup>
                <FormGroup className="Col-8-4" >
                     {errors.x_BKR_NAME && errors.x_BKR_NAME.types && <span id="Err_msg">{errors.x_BKR_NAME.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
   
                <FormGroup className="Col-1-2" label="BROKER OWN ADDRESS">

                </FormGroup>
             
                <FormGroup className="Col-3-5" >
                 
                    <InputGroup id="inputCCOMMADR1" defaultValue={def_d_CCOMMADR1} value={def_d_CCOMMADR1} placeholder="Address1..." onChange={utils.handleStringChange(n => setdef_d_CCOMMADR1(n))} /> 
                        {errors.d_CCOMMADR1 && errors.d_CCOMMADR1.types && <span id="Err_msg">{errors.d_CCOMMADR1.types.message}</span>}
               
                    <InputGroup id="inputCCOMMADR2" defaultValue={def_d_CCOMMADR2} value={def_d_CCOMMADR2} placeholder="Address2..." onChange={utils.handleStringChange(n => setdef_d_CCOMMADR2(n))} /> 
                    {errors.d_CCOMMADR2 && errors.d_CCOMMADR2.types && <span id="Err_msg">{errors.d_CCOMMADR2.types.message}</span>}
                    <InputGroup id="inputCCOMMADR3" defaultValue={def_d_CCOMMADR3} value={def_d_CCOMMADR3} placeholder="Address3..." onChange={utils.handleStringChange(n => setdef_d_CCOMMADR3(n))} /> 
                    {errors.d_CCOMMADR3 && errors.d_CCOMMADR3.types && <span id="Err_msg">{errors.d_CCOMMADR3.types.message}</span>}
                    <InputGroup id="inputCCOMMADR4" defaultValue={def_d_CCOMMADR4} value={def_d_CCOMMADR4} placeholder="Address4..." onChange={utils.handleStringChange(n => setdef_d_CCOMMADR4(n))} />    
                    {errors.d_CCOMMADR4 && errors.d_CCOMMADR4.types && <span id="Err_msg">{errors.d_CCOMMADR4.types.message}</span>}                                                                               
                </FormGroup>
              
                {/*
                <FormGroup className="Col-8-4" >
                    {errors.d_CCOMMADR1 && errors.d_CCOMMADR1.types && <span id="Err_msg">{errors.d_CCOMMADR1.types.message}</span>}
                    {errors.d_CCOMMADR2 && errors.d_CCOMMADR2.types && <span id="Err_msg">{errors.d_CCOMMADR2.types.message}</span>}
                    {errors.d_CCOMMADR3 && errors.d_CCOMMADR3.types && <span id="Err_msg">{errors.d_CCOMMADR3.types.message}</span>}
                    {errors.d_CCOMMADR4 && errors.d_CCOMMADR4.types && <span id="Err_msg">{errors.d_CCOMMADR4.types.message}</span>}                                        
                </FormGroup>
                */}

   
            </div>
            <div className="Spacing-V-16"></div>
            <br></br>
            <p>Notes</p>
            <div>
                <div>Re: HKEx Circular CBU/CC/DNS/034/2003</div>
            
            </div >
        </form>
    )
}

interface BcanConfigMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function BcanConfigMain({ gsb }: BcanConfigMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as CCRConfig[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as CCRConfig)
    const [BlankAc, setBlankAc] = useState({} as CCRConfig)
    const [sbConfigRec, setsbConfigRec] = useState({} as sbConfig)

    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"
   
 


    useEffect(() => {
        (async () => {
            try {

             
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("BcanConfigMain disp user_key: ", res.data.Flag.user_key)
                //console.log("BcanConfigMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("BcanConfigMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("BcanConfigMain disp GsbFlag: ", GsbFlag)
                //console.log("BcanConfigMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("BcanConfigMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                //console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("BcanConfigMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("BcanConfigMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("BcanConfigMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                if ( GsbFlag.isProduction == "Y" ) {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
} else {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
}
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                // usually A/E code is prefixed with C, but some user may use others e.g. Upbest uses A for A/E
                // TODO: Read A/E prefix from config
                // fixed can read true A/E
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CCRConfig",
                        cAction: "ListRec",
                    });
                setData(res.data.data)

                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                    console.log("ccr currentAc", res.data.data[0])
                }

               
                console.log("ccr currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    const PrevRecProcess = async (BcanConfig: CCRConfig) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "BcanConfig", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (BcanConfig: CCRConfig) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "BcanConfig", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (BcanConfig: CCRConfig) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "BcanConfig", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }


    const newOnSave = async (BcanConfig: CCRConfig) => {
/*        
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "BcanConfig", cAction: "AddRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record added")

            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const editOnSave = async (BcanConfig: CCRConfig) => {
        try {
            console.log("call editOnSave", BcanConfig)
            const res = await gsb.post('/Master', {sb_data: BcanConfig, cPgmId: "CCRConfig", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data) 
            showSuccess("CCR Configuration Record Saved")
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <CCRConfigView gsb={gsb} CCRConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></CCRConfigView>
    switch (currentMode) {
        case "edit":
            detail = <CCRConfigEdit gsb={gsb} CCRConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></CCRConfigEdit>
            break
        case "new":
            detail = <CCRConfigEdit gsb={gsb} CCRConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></CCRConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    
    
    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>CCR Configuration</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default BcanConfigMain